const isError = (error) => error instanceof Error;

const isEmpty = (data) =>
  [Object, Array].includes((data || {}).constructor) && !Object.entries(data || {}).length;

export { isError, isEmpty };
